"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TerraformValidConfigurationTypes = exports.TFLineTypes = void 0;
var TFLineTypes;
(function (TFLineTypes) {
    TFLineTypes[TFLineTypes["TYPE_START"] = 1] = "TYPE_START";
    TFLineTypes[TFLineTypes["TYPE_END"] = 2] = "TYPE_END";
    TFLineTypes[TFLineTypes["TYPE_START_AND_END"] = 3] = "TYPE_START_AND_END";
    TFLineTypes[TFLineTypes["SUB_TYPE"] = 4] = "SUB_TYPE";
    TFLineTypes[TFLineTypes["STRING"] = 5] = "STRING";
    TFLineTypes[TFLineTypes["MULTILINE_STRING"] = 6] = "MULTILINE_STRING";
    TFLineTypes[TFLineTypes["ARRAY_START_AND_END"] = 7] = "ARRAY_START_AND_END";
    TFLineTypes[TFLineTypes["ARRAY_START"] = 8] = "ARRAY_START";
    TFLineTypes[TFLineTypes["ARRAY_END"] = 9] = "ARRAY_END";
    TFLineTypes[TFLineTypes["OBJECT_START_AND_END"] = 10] = "OBJECT_START_AND_END";
    TFLineTypes[TFLineTypes["OBJECT_START"] = 11] = "OBJECT_START";
    TFLineTypes[TFLineTypes["OBJECT_END"] = 12] = "OBJECT_END";
    TFLineTypes[TFLineTypes["FUNCTION_START_AND_END"] = 13] = "FUNCTION_START_AND_END";
    TFLineTypes[TFLineTypes["FUNCTION_START"] = 14] = "FUNCTION_START";
    TFLineTypes[TFLineTypes["FUNCTION_END"] = 15] = "FUNCTION_END";
    TFLineTypes[TFLineTypes["IGNORE"] = 99] = "IGNORE";
})(TFLineTypes = exports.TFLineTypes || (exports.TFLineTypes = {}));
exports.TerraformValidConfigurationTypes = ['terraform', 'locals'];
//# sourceMappingURL=types.js.map